import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Orders from '../../components/user/orders/Orders';
import Profile from '../../components/user/profile/Profile';

const User = () => {
    return (
        <div className="user">
          <Routes>
            <Route path="/*" element={<Orders />}></Route>
            <Route path="profile" element={<Profile />}></Route>
            {/* <Route path="order-details/:id" element={<CouponManagement />}></Route> */}
          </Routes>
        </div>
    );
};

export default User;